import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import useToast from 'hooks/useToast'

const Logout = () => {
  const history = useHistory()
  const { toastSuccess } = useToast()

  useEffect(() => {
    localStorage.removeItem('userToken')
    toastSuccess('Logout Successfully')
    history.push('/login')
  })
  return <></>
}

export default Logout
